import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationNames, StorageValues } from '../consts';
import { AuthenticationService } from '../services/auth.service';
import { DecryptAesClientSide } from '../encryption';
import { ExceptionsService } from '../services/utelize/general/exceptions-service';
import { Injectable } from '@angular/core';
import { StorageService } from '../services/utelize/general/storage-service';
import { SystemUserDTO } from '../models/system/user/system-user.dto';

@Injectable({ providedIn: 'root' })

export class AuthGuard  {
  constructor(
    private authenticationService: AuthenticationService,
    private exceptionsService    : ExceptionsService,
    private storageService       : StorageService,
    private router               : Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var forceLogout: boolean=false;

    try {
      if(this.storageService.getItem(StorageValues.encCurrentUser)) {
  
        var systemUser: SystemUserDTO=this.authenticationService.currentUserObject();

        if(!DecryptAesClientSide(this.storageService.getItem(StorageValues.encSsoLoggedIn)) && systemUser.userInfoFromInview) {
          
          if (systemUser.userInfoFromInview.UserId != systemUser.inviewUserId) {
            forceLogout=true;
            throw new Error(`${ApplicationNames.InviewApi} UserId (${systemUser.userInfoFromInview.UserId}) does not match ${ApplicationNames.eSimPlatform} UserId (${systemUser.inviewUserId})`);
          }
            
          if (systemUser.userInfoFromInview.CompanyId != systemUser.inviewCompanyId) {
            forceLogout=true;
            throw new Error(`${ApplicationNames.InviewApi} CompanyId (${systemUser.userInfoFromInview.CompanyId}) does not match ${ApplicationNames.eSimPlatform} CompanyId (${systemUser.inviewCompanyId})`);
          }
          
          if (this.storageService.getItem(StorageValues.encTotpRequired) &&
              !this.storageService.getItem(StorageValues.encTotpAuthenticated)) {
                forceLogout=true;
            throw new Error(`User is not 2FA authenticated`);
          }
        }

        return true;
      }
      
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
    finally {
      if (forceLogout) {
        this.authenticationService.logout();
        this.router.navigate(['/auth/login']);
      }
    }
  }
}
